module.exports = __webpack_public_path__ + "img/interest-5.74ceeab8.png";